import type { APIOrganizationDataGrant } from '@visorpro/client'
import type { MRT_Cell } from 'material-react-table'
import { observer } from 'mobx-react-lite'
import type { Stores } from '../../../../util/store'
import { useUserById } from '../../../../stores/user-store'
import { formatUserName } from '../../../../util/format'

export interface GrantedByCellOptions {
    cell: MRT_Cell<APIOrganizationDataGrant, any>
    stores: Stores
}

export const GrantedByCell = observer<GrantedByCellOptions>(
    ({ cell, stores }) => {
        const userId = cell.getValue<string>()
        const user = useUserById(stores.users, userId)

        if (user) {
            const name = formatUserName(user)

            if (name) {
                return name
            }
        }

        return userId
    },
)
